<div class="container">
  <p class="headline">Choose your plan</p>

  <div class="plans">
    <app-plan-chooser-item
      *ngFor="let plan of plans"
      [plan]="plan"
      class="plan"
    ></app-plan-chooser-item>
  </div>
</div>
